webpackJsonp([3],{

/***/ "0am5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("wSez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);

var _arguments = arguments;
// import { ROOT_URL } from '../../../config/dev.env'
 // 引入axios

// import { getCookie, alert } from './mUtils'
// import qs from 'qs' //引入qs

// var _xhr = new XMLHttpRequest();
// var allow_cors = "withCredentials" in _xhr; // 查看浏览器是否支持cookie跨域方式

var fetch = function fetch(method, url, data, option) {
  var options = option || {
    baseURL: "https://backend.jegotrip.com.cn/marketing",
    withCredentials: false, // default
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      // 'Content-Type': 'application/json',
      'Content-Type': 'application/json;charset=UTF-8'

    },
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 600; // 默认
    }
    // console.log('arguments',arguments[2]);
  };if (method == 'GET') {
    options.method = 'GET';
    options.url = url;
    if (_arguments[2]) {
      options.params = data;
    }
    var request = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.request(options); // api 原生的返回
  } else if (method == 'POST') {
    // data = JSON.stringify(data);
    var request = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data, options);
  }

  __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].open({
    text: '加载中...',
    spinnerType: 'snake'
  });

  var reqiestObj = request.then(function (res) {
    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
    // 后台返回数据

    var data = res.data;

    // 后台返回状态

    if (typeof data === 'string') {
      data = JSON.parse(data);
      var code = data.code;
    } else {
      var code = data.code;
    }

    // 后台响应成功
    if (code == 100) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
    } else {
      // 后台响应失败   可能有各种状态码
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
    }
  });

  return reqiestObj;
};

/***/ }),

/***/ "EWIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I0Dc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetSkuCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAddJegoUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchMobieleNcryption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__("BXx+");


var fetchGetActivity = function fetchGetActivity(id) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetch */])('POST', '/api/activity/getActivity', {

        id: id

    });
};

var fetchGetChannel = function fetchGetChannel(id) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetch */])('GET', '/api/channel/getChannelsByActId', {
        id: id
    });
};

var fetchGetCoupon = function fetchGetCoupon(countryCode, mobile, releaseId, couponStoreType, actId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetch */])('POST', '/api/coupon/getCoupon', {

        countryCode: countryCode, mobile: mobile, releaseId: releaseId, couponStoreType: couponStoreType, actId: actId

    });
};

// 领取sku码 
var fetchGetSkuCoupon = function fetchGetSkuCoupon(countryCode, mobile, sku, actId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetch */])('POST', '/api/coupon/getSkuCoupon', {

        countryCode: countryCode, mobile: mobile, sku: sku, actId: actId

    });
};

// 存储用户信息
var fetchAddJegoUser = function fetchAddJegoUser(countryCode, mobile, jegoUserId, countryName, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetch */])('POST', '/api/jegoUser/addJegoUser', {

        countryCode: countryCode, mobile: mobile, jegoUserId: jegoUserId, countryName: countryName, token: token

    });
};
var fetchMobieleNcryption = function fetchMobieleNcryption(mobile) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetch */])('GET', '/api/jegoUser/mobileEncryption', {
        mobile: mobile
    });
};

/***/ }),

/***/ "KlD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","max-width":"750px"}},[_c('transition',{attrs:{"mode":"out-in"}},[(!_vm.$route.params.isAlive && _vm.IsRouterAlive)?_c('router-view',{class:{'child-view': !_vm.$route.meta.keepAlive && _vm.$route.meta.showAnimation}}):_vm._e()],1),_vm._v(" "),_c('keep-alive',[(_vm.$route.params.isAlive && _vm.IsRouterAlive)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e38ec310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KlD5");
function injectStyle (ssrContext) {
  __webpack_require__("0am5")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e38ec310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_lazyload_style__ = __webpack_require__("Pxkw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_lazyload__ = __webpack_require__("aAzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("kV13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_style_min_css__ = __webpack_require__("rx0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_style_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_style_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_bus__ = __webpack_require__("xt+v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_css_reset_css__ = __webpack_require__("EWIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_js_rem_js__ = __webpack_require__("kNAH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_js_rem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_js_rem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clipboard2__ = __webpack_require__("urnN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_clipboard2__);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import MintUI from 'mint-ui';







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_lazyload__["a" /* default */], {
  // loading: '../static/img/loading-grey.png'
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].tokenUseFlag = false;

// if (process.env.NODE_ENV === "production") {
//   Vue.prototype.baseurl = "https://app.jegotrip.com.cn";           //正式环境
// } else {
//  Vue.prototype.baseurl = "https://test01.jegotrip.com.cn";       //集成环境 (本地环境与测试环境都是这个接口)
// }

//
// // 分享操作
// Vue.prototype._ReParams = function (params) {
//     var t = this;
//     console.log("ReParams")
//     if (!params) params = {};
//     params.activity_id = t._getAPPParams().activity_id;
//     return params;
// }
// Vue.prototype._activity = function (m, d, params = {}) {
//     var t = this;
//     params = t._ReParams(params);
//     return new Promise((resolve, reject) => {
//         var url = t.baseurl + prefix + "m=" + m + "&do=" + d;
//         params.r = "activity";
//         axios.post(url, params).then(
//             res => {
//                 console.log(`${url} params`, params);
//                 console.log(`${url} res`, res);
//                 if (res.status == 200) {
//                     resolve(res.data);
//                 } else {
//                     reject(res.statusText);
//                 }
//             },
//             rej => {
//                 reject(rej);
//                 console.log(rej);
//             }
//         );
//     });
// };
// Vue.prototype._wxReadySuccessFun = function () {
//     var t = this;
//     var userid = 0;
//     var app_login_user = localStorage.getItem(config.login_key);
//     console.log("app:app_login_user");
//     console.log(app_login_user);
//     if (app_login_user) app_login_user = JSON.parse(app_login_user);
//     if (app_login_user && app_login_user.userid) {
//         userid = app_login_user.userid;
//     }
//     var initurl = t._getInitUrl();
//
//     // var myurl = `${initurl.href}?a=${
//     //   initurl.urldata.a ? initurl.urldata.a : 2
//     // }&sid=${userid}&isauth=1`;
//     var myurl =  location.href
//
//     var share_params = {
//         title: title,
//         link: myurl,
//         // imgUrl:"http://test01.jegotrip.com.cn/wyx/appwap/images/logoWhite.png",
//         imgUrl: `${initurl.roothref}icon_share.png`
//     };
//     console.log("share_params", share_params);
//     wx.updateAppMessageShareData({
//         title: share_params.title, // 分享标题
//         link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//         desc: "我已经领取了，也送你一份。", // 分享描述
//         imgUrl: share_params.imgUrl, // 分享图标
//         success: function () {
//             // 设置成功
//             console.log("updateAppMessageShareData success ");
//         },
//         fail: function (res) {
//             console.log("updateAppMessageShareData fail ", res);
//         }
//     });
//     wx.updateTimelineShareData({
//         title: share_params.title, // 分享标题
//         link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//         imgUrl: share_params.imgUrl, // 分享图标
//         success: function () {
//             // 设置成功
//             console.log("updateTimelineShareData success ");
//         },
//         fail: function (res) {
//             console.log("updateTimelineShareData fail ", res);
//         }
//     });
// };
// //获得微信sdk配置
// Vue.prototype._getJSConfig = function () {
//     var t = this;
//     console.log("getjsconfig t.urldata", t.urlData);
//     // var url = window.location.href;
//     // var url2 = "",
//     //   url3 = "";
//     // if (url.indexOf("?") >= 0) {
//     //   url2 = url.substring(0, url.indexOf("?"));
//     // }
//     // if (url.lastIndexOf("#") >= 0) {
//     //   url3 = url.substring(0, url.lastIndexOf("#"));
//     // }
//     var initurl = t._getInitUrl();
//     console.log("initurl", initurl);
//     var apilist = ["updateAppMessageShareData", "updateTimelineShareData"];
//     // 记录进入app时的url
//     if (typeof window.entryUrl === "undefined" || window.entryUrl === "") {
//         window.entryUrl = location.href.split("#")[0];
//     }
//     // 进行签名的时候  Android 不用使用之前的链接， ios 需要
//     let signLink = /(Android)/i.test(navigator.userAgent)
//         ? location.href.split("#")[0]
//         : window.entryUrl;
//     var params = {
//         js_config: {
//             jsApiUrl: signLink,
//             jsApiList: apilist
//         }
//     };
//
//     t._activity("activity", "Activity.getJSConfig", params)
//         .then(res => {
//             console.log("***微信sdk配置***");
//             if (res.status == 0 && res.data && res.data.code == "0") {
//                 var res = res.data.body;
//                 wx.config({
//                     debug: false, // 开启调试模式,
//                     appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
//                     timestamp: res.timestamp, // 必填，生成签名的时间戳
//                     nonceStr: res.nonceStr, // 必填，生成签名的随机串
//                     signature: res.signature, // 必填，签名，见附录1
//                     jsApiList: apilist // 必填，需要使用的JS接口列表，所有JS接口列表见附录2 scanQRCode
//                 });
//                 // var shareInfo = t.shareInfo;
//                 // var title = shareInfo.shareTitle ? encodeURIComponent(shareInfo.shareTitle) : '无忧行邀您组队瓜分百分红包'
//                 wx.ready(function () {
//                     // t.wx_success = 1;
//                     console.log("wxsdk success");
//                     t._wxReadySuccessFun();
//                 });
//                 wx.error(function (res) {
//                     console.log("wxsdk error", res);
//                     // t.wx_success = 0;
//                     // Toast("扫码组件加载失败，请刷新后重试");
//                 });
//             }
//         })
//         .catch(error => {
//             console.log(`error:${error}`);
//         });
//
// };
//获得通用的APP参数
// Vue.prototype._getBrowser = function () {
//     var result = 0;
//     var userAgent = window.navigator.userAgent.toLowerCase();
//     if (userAgent.match(/jegotrip/i) == "jegotrip") result = 1;
//     else if (userAgent.match(/micromessenger/i) == "micromessenger") result = 2;
//     return result;
// };


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  template: '<App/>',
  data: {
    Bus: __WEBPACK_IMPORTED_MODULE_6__common_js_bus__["a" /* default */]
  },
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] },
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  }
});

/***/ }),

/***/ "PIn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setSessionStore */
/* unused harmony export getSessionStore */
/* unused harmony export removeSessionStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function isLocalStorageSupported() {
    var testKey = 'test',
        storage = window.sessionStorage;
    try {
        storage.setItem(testKey, 'testValue');
        storage.removeItem(testKey);
        return true;
    } catch (error) {
        return false;
    }
}
// 设置sessionStorage
var setSessionStore = function setSessionStore(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
        content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
    }
    if (isLocalStorageSupported) {
        window.sessionStorage.setItem(name, content);
    } else {
        setCookie(name, content);
    }
};

// 获取sessionStorage
var getSessionStore = function getSessionStore(name) {
    if (!name) return;
    if (isLocalStorageSupported) {
        return window.sessionStorage.getItem(name);
    } else {
        getCookie(name, content);
    }
};

// 删除sessionStorage
var removeSessionStore = function removeSessionStore(name) {
    if (!name) return;
    if (isLocalStorageSupported) {
        window.sessionStorage.removeItem(name);
    } else {
        removeCookie(name);
    }
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("kV13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("5inH");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// 首页
var home = function home(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__("nU8l"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//测试页面
var test = function test(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__("ylNe"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    //mode: 'history',  //去除#
    // base: '/dist/',        //这个配置也很重要，否则会出现页面空白情况
    routes: [{
        path: '/',
        name: 'home',
        component: home,
        meta: { showAnimation: true, title: '首页' }
    }, {
        path: '/home',
        name: 'home',
        component: home,
        meta: {
            showAnimation: true, title: '首页'
        }
    }]
}));

/***/ }),

/***/ "iqjr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kAyd":
/***/ (function(module, exports) {

// import {wxShare } from '@/common/js/succestechApi.js';
// import wx from 'weixin-js-sdk'
// import {Toast,Loadmore,MessageBox} from 'mint-ui';
// import axios from 'axios' // 引入axios
// export const   getWXConfig = function(sdata) {
//
//
//     /*方式一开始*/
//
//     var url = window.location.href.replace(window.location.hash, '');
//     if(process.env.NODE_ENV === 'production'){
//         axios.get('https://www.saisaisys.com/likun/h5/common/getWXConfig?url='+url)
//             .then(function (result) {
//
//                 var res = result.data;
//                 if( typeof res == 'string') {
//                     res = JSON.parse(res);
//                 }
//                 if(res.code == 200){
//                     wx.config({
//                         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//                         signature: res.data.signature,// 必填，签名
//                         appId: res.data.appid, // 必填，公众号的唯一标识
//                         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
//                         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
//                         jsApiList: [
//                             'updateAppMessageShareData', //分享给好友
//                             'updateTimelineShareData', //分享到朋友圈
//                             'onMenuShareAppMessage',    // pc端分享给好友
//                         ] // 必填，需要使用的JS接口列表
//                     });
//
//                 } else{
//                     Toast({
//                         message: res.msg ? res.msg : "分享失败",
//                         position: "middle",
//                         className: "tipsInfo"
//                     });
//                 }
//             }).catch((error) => {
//
//                 console.log(error);
//
//             })
//     }
//
//     /*方式一结束*/
//
//     /*方式二开始*/
//
//     //var url = window.location.href.replace(window.location.hash, '');
//     //wxShare(url).then(res => {
//     //    if(res.code === 200){
//     //        console.log('外层',res.code,typeof res.code);
//     //        console.log(res.data.signature);
//     //        console.log(res.data.appid);
//     //        console.log(res.data.nonceStr);
//     //        console.log(res.data.timestamp);
//     //        if(res.code == 200){
//     //            console.log('成功!!!!',res.code);
//     //            wx.config({
//     //                debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//     //                signature: res.data.signature,// 必填，签名
//     //                appId: res.data.appid, // 必填，公众号的唯一标识
//     //                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
//     //                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
//     //                jsApiList: [
//     //                    'updateAppMessageShareData', //分享给好友
//     //                ] // 必填，需要使用的JS接口列表
//     //            });
//     //
//     //        } else{
//     //            console.log('失败!!!!',res.code);
//     //            Toast({
//     //                message: res.msg ? res.msg : "分享失败",
//     //                position: "middle",
//     //                className: "tipsInfo"
//     //            });
//     //        }
//     //    } else{
//     //        Toast({
//     //            message: res.msg ? res.msg : "获取数据失败",
//     //            position: "middle",
//     //            className: "tipsInfo"
//     //        });
//     //    }
//     //})
//     /*方式二结束*/
//
//
//     wx.ready(function(){            //需在用户可能点击分享按钮前就先调用
//
//         console.log('进入wx.ready');
//         //sdata = {
//         //    imgUrl: "http://jsaxwv.natappfree.cc/share/img/blog/logo.png", // 分享图标
//         //    link: location.href,
//         //    title: "燕子约一周年庆典", // 分享标题
//         //    desc: "分享描述", // 分享描述
//         //    success: function () {
//         //        alert("分享成功");
//         //    },
//         //    cancel: function () {
//         //        alert("分享失败");
//         //        // error函数 // 错误error
//         //    }
//         //};
//
//         wx.updateTimelineShareData(sdata);// 分享到朋友圈
//
//         if(typeof wx.updateAppMessageShareData == 'function') {
//                 console.log('新版本');
//             wx.updateAppMessageShareData(sdata);// 发送给朋友
//         } else if(typeof wx.onMenuShareAppMessage == 'function') {
//             console.log('旧版本');
//             wx.onMenuShareAppMessage(sdata);// 发送给朋友
//         }
//
//     });
//
//     wx.error(function(res){
//         console.log('失败',res);
//         // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
//     });
//
// }

/***/ }),

/***/ "kNAH":
/***/ (function(module, exports) {

(function(doc,win){var ua=window.navigator.userAgent.toLowerCase();function isIOS(ua){if(ua.match(/(iPhone|iPod|iPad)/i)){return true}else{return false}}function isANDROID(ua){if(ua.match(/android/i)){return true}else{return false}}var docEl=doc.documentElement,resizeEvt='orientationchange'in window?'orientationchange':'resize',recalc=function(){var clientWidth=docEl.clientWidth;if(!clientWidth){return}if(clientWidth>750&&!isIOS(ua)&&!isANDROID(ua)){docEl.style.fontSize=50*(750/375)+'px';docEl.style.maxWidth=750+'px'}else{docEl.style.fontSize=50*(clientWidth/375)+'px';docEl.style.maxWidth='auto'}};if(!doc.addEventListener){return}win.addEventListener(resizeEvt,recalc,false);doc.addEventListener('DOMContentLoaded',recalc,false)})(document,window);


/***/ }),

/***/ "rx0o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_sessionStorage__ = __webpack_require__("PIn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_fetch__ = __webpack_require__("BXx+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_succestechApi_js__ = __webpack_require__("I0Dc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_getWXConfig_js__ = __webpack_require__("kAyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_getWXConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_js_getWXConfig_js__);
//
//
//
//
//
//
//
//
//
//
//
//


// import nav from './components/nav/m-nav';





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    provide: function provide() {
        return {
            reload: this.reload // 向所有子组件暴露一个方法用于刷新当前页面
        };
    },
    data: function data() {
        return {
            IsRouterAlive: true
        };
    },
    created: function created() {},
    mounted: function mounted() {
        // H5在ios弹窗状态下调起输入法后关闭输入法页面元素错位解决办法
        document.body.addEventListener('focusout', function () {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        });
    },

    methods: {
        reload: function reload() {
            this.IsRouterAlive = false;
            this.$nextTick(function () {
                this.IsRouterAlive = true;
            });
        }
    },
    watch: {
        '$route': function $route(to, from) {
            // 判断是否显示调试按钮
            if (to.query.vConsole == 1) {
                var vConsole = new VConsole();
            }
        }
    }
});

/***/ }),

/***/ "xt+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("kV13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");



var Bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({

    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */]

});
/* harmony default export */ __webpack_exports__["a"] = (Bus);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1c828d7af6a8517bd4fb.1600842285483.js